/** 轮询遇到 5xx 时的退避参数 */
export const POLL_SERVER_BACKOFF_MULTIPLIER = 2;
export const POLL_SERVER_BACKOFF_MAX_LEVEL = 5;
export const POLL_SERVER_BACKOFF_MAX_INTERVAL_MS = 120_000;

/** @param {unknown} err axios / request 错误 */
export function isPollServerError(err) {
  const status = err?.response?.status;
  return typeof status === 'number' && status >= 500 && status < 600;
}

/**
 * 轮询 5xx 退避：逐级拉长间隔，成功一次即恢复基线频率。
 * @param {{
 *   baseIntervalMs?: number,
 *   getBaseIntervalMs?: () => number,
 *   multiplier?: number,
 *   maxLevel?: number,
 *   maxIntervalMs?: number,
 * }} options
 */
export function createPollServerBackoff(options) {
  const multiplier = options.multiplier ?? POLL_SERVER_BACKOFF_MULTIPLIER;
  const maxLevel = options.maxLevel ?? POLL_SERVER_BACKOFF_MAX_LEVEL;
  const maxIntervalMs = options.maxIntervalMs ?? POLL_SERVER_BACKOFF_MAX_INTERVAL_MS;

  function resolveBaseIntervalMs() {
    if (typeof options.getBaseIntervalMs === 'function') {
      const n = Number(options.getBaseIntervalMs());
      if (Number.isFinite(n) && n > 0) return n;
    }
    return Math.max(1, Number(options.baseIntervalMs) || 5000);
  }

  let level = 0;

  function getIntervalMs() {
    const baseIntervalMs = resolveBaseIntervalMs();
    if (level <= 0) return baseIntervalMs;
    const scaled = baseIntervalMs * multiplier ** level;
    return Math.min(scaled, maxIntervalMs);
  }

  return {
    get level() {
      return level;
    },
    getIntervalMs,
    recordSuccess() {
      level = 0;
    },
    recordServerError() {
      if (level < maxLevel) level += 1;
    },
    reset() {
      level = 0;
    },
  };
}
